// extracted by mini-css-extract-plugin
export var cls2 = "index-module--cls2--aQtjH";
export var facebook = "index-module--facebook--sZU5r";
export var sidebar = "index-module--sidebar--YR44M";
export var socialPeace = "index-module--socialPeace--f4BxL";